import { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';

import { PageSlugs } from 'types/pages';

import Page from 'models/Page';

import { fillPage } from 'utils/translations';

import { single as singlePage } from 'requests/pages';

import Component from './component';
import { Props } from './types';

export async function getServerSideProps(context: GetServerSidePropsContext): Promise<GetServerSidePropsResult<Props>> {
    let page: Page = null;

    try {
        await Promise.all([
            singlePage({ slug: PageSlugs.Home }),
        ]).then(responses => {
            page = responses[0];
        });
    } catch (error) {
        console.error(error);
    }

    let pageTranslations = JSON.parse(JSON.stringify(require('locales/pl/pages/regulations')?.default));
    const fillValues = {};
    pageTranslations = fillPage(pageTranslations, page, fillValues);

    return {
        props: {
            pageTranslations,
        },
    };
}

export default Component;

